import { render } from "./Edits.vue?vue&type=template&id=0a2928d1"
import script from "./Edits.vue?vue&type=script&lang=js"
export * from "./Edits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__